import { render } from "./banner.vue?vue&type=template&id=c8746a3c&scoped=true"
const script = {}

import "./banner.vue?vue&type=style&index=0&id=c8746a3c&lang=scss&scoped=true"

import exportComponent from "/Users/baikaifa/Desktop/ubang-deploy-work/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.42_vue@3.5.42_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8746a3c"]])

export default __exports__